import axios from "axios";

const PARSI_API_URL = "https://okalaapi.parsimap.ir/";
const parsiMapAccessToken = "p1176d27b851984ebd8191ab0d54caecb52c995e58";

interface ISearchBody<T> {
  district: T;
  search_text: string;
}

interface IReverseLocationBody<T> {
  location: T;
}

// ------------ parsi map api call ----------------
export const parsiMapSearchAddress = async (body: ISearchBody<string>) => {
  delete axios.defaults.headers.common["Authorization"];
  const data = await axios.get(`${PARSI_API_URL}geocode/forward?district=${body.district}&key=${parsiMapAccessToken}&search_text=${body.search_text}&only_in_district=false`);
  return await data?.data;
};

export const parsiMapReverseLocation = async (body: IReverseLocationBody<string>) => {
  delete axios.defaults.headers.common["Authorization"];
  const data = await axios.get(`${PARSI_API_URL}geocode/reverse?key=${parsiMapAccessToken}&location=${body.location}&plate=true`);
  return await data?.data;
};
